import { apiGet } from "../client";
import type { IExamAssignmentAnalysisReportResponse } from "./types";
import { useQuery } from "@tanstack/react-query";

export interface IAnalysisReportFilters {
  exam_time_group_id?: string;
  current_group_id?: string;
  user_ids?: string;
}

export async function getExamAssignmentAnalysisReport(
  id: string,
  filters?: IAnalysisReportFilters
) {
  const params = new URLSearchParams();

  if (filters?.exam_time_group_id) {
    params.append("exam_time_group_id", filters.exam_time_group_id);
  }

  if (filters?.current_group_id) {
    params.append("current_group_id", filters.current_group_id);
  }

  if (filters?.user_ids) {
    params.append("user_ids", filters.user_ids);
  }

  const queryString = params.toString();
  const url = queryString
    ? `/exam_assignments/${id}/analysis-report?${queryString}`
    : `/exam_assignments/${id}/analysis-report`;

  const response = await apiGet<IExamAssignmentAnalysisReportResponse>(url);
  return response.data;
}

export function useQueryGetExamAssignmentAnalysisReport(
  id: string,
  filters?: IAnalysisReportFilters,
  options: { enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: ["examAssignmentAnalysisReport", id, filters],
    queryFn: () => getExamAssignmentAnalysisReport(id, filters),
    enabled: !!id && options.enabled !== false,
  });
}
